import type { SliderProps as MuiSliderProps } from '@mui/material/Slider';

import MuiSlider from '@mui/material/Slider';
import classNames from 'classnames';
import React from 'react';

import { HelperMessage } from '../../HelperMessage';
import { ErrorMessage } from '../../ErrorMessage';

export interface SliderProps extends MuiSliderProps {
  errors?: string | string[];
  helperText?: string;
  fullWidth?: boolean;
}

export const Slider = React.forwardRef(
  (
    { className, errors, fullWidth, helperText, value, ...props }: SliderProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <div className={classNames(className, { 'w-full': fullWidth })}>
        <MuiSlider {...props} className={className} ref={ref} />
        {helperText && (
          <HelperMessage className="mt-1 ml-2">{helperText}</HelperMessage>
        )}
        {errors && <ErrorMessage className="mt-1" errors={errors} />}
      </div>
    );
  },
);

Slider.displayName = 'Slider';
